import { ValidationFunctionResult } from '../../../../shared/types/validation-function-result';
import { CommissionTierItemDto } from '../../dtos/commission-tier-item.dto';
import { commissionTierItemSchema } from '../schemas/commission-tier-item.schema';

/**
 * Validates record data for creation or update.
 * @param record - The record to validate.
 * @param abortEarly - Whether to abort the validation on the first error.
 * @returns The validation result.
 */
export const canCreateOrUpdate = (
	record: CommissionTierItemDto,

	abortEarly: boolean = false,
): ValidationFunctionResult => {
	// Check
	if (!record) throw new Error('record is required.');

	// Validate
	const { error } = commissionTierItemSchema().validate(record, {
		abortEarly,
	});

	// Check
	if (error) {
		return {
			isValid: false,
			errors: error.details?.map((e) => e.message),
		};
	}

	// Return
	return { isValid: true };
};
